<template>
  <v-row no-gutters class="mb-3 mt-4">
    <v-col cols="12">
      <div class="d-flex align-center">
        <AvatarComponent size="36" isMine/>
        <v-textarea
          v-model="text"
          :append-icon="'fas fa-paper-plane'"
          rounded
          name="comment"
          :placeholder="$gettext('Write a comment ...')"
          class="ml-3 pt-0 text-caption inputComment"
          hide-details="auto"
          @click:append.prevent="send($event)"
          @keydown.enter.exact.prevent="send($event, 'enter')"
          ref="commentInput"
          single-line
          auto-grow
          rows="1"
          :disabled="isDisable"
        ></v-textarea>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "CommentInput",
  props: {
    entityId: { type: Number, default: null },
    entityName: { type: String, default: null },
    parentId: { type: Number, default: null },
  },
  data: () => ({
    text: "",
    isDisable: false,
  }),
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    async send(event, type = null) {
      this.isDisable = true
      if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      }
      console.log(this.text);
      if(!this.text) {
        this.isDisable = false
        return;
      } else {
        let appendBtn = event.target;
        if (type) {
          appendBtn = this.$refs.commentInput.$refs["append-inner"].childNodes[0]
            .childNodes[0];
        }
        this.$store.commit("setActiveElement", appendBtn);
        const result = await this.$store.dispatch("newComment", {
          entityId: this.entityId,
          entityName: this.entityName,
          parent: this.parentId,
          text: this.text,
        });
        if(result.error) {
          if(result.error.message == 'friend blocked') {
            const result = await this.$store.state.toggle.dialogConfirm.open(
              this.$gettext("Could not comment !!!"),
              this.$gettext("This comment can not be created because this user blocked you"),
              { color: "warning" },
              true
            );
          } else if(result.error.message == 'friend blocking') {
            const result = await this.$store.state.toggle.dialogConfirm.open(
              this.$gettext("Could not comment !!!"),
              this.$gettext("This comment can not be created because you are blocking this user"),
              { color: "warning" },
              true
            );
          }
          this.isDisable = false
          return
        }
        this.isDisable = false
        this.text = "";
        this.$emit("newComment", result);
        this.$refs.commentInput.$el.children[0].children[0].children[0].children[0].blur();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.inputComment {
  &.v-text-field {
    .v-input__slot {
      box-shadow: none !important;
      background: #f2f2f2 !important;
      margin-bottom: 0 !important;
      padding: 5px 20px !important;
      font-size: 15px;
      line-height: 20px;
      &:before {
        display: none;
      }
      textarea {
        line-height: 24px;
        padding: 6px 0px;
      }
    }
  }
}
</style>
